var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrayDefault = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#tray_default_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.5 15c-.413 0-.766-.118-1.06-.353-.294-.235-.44-.517-.44-.847V12h1.5v1.8h9V12H14v1.8c0 .33-.147.613-.441.848A1.64 1.64 0 0 1 12.5 15h-9z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.005 1.95c0-.522.445-.95.995-.95h4l3 2.85v5.7c0 .522-.45.95-1 .95H4.995c-.55 0-.995-.428-.995-.95l.005-7.6zM10.5 6.5l-.705-.705L8.5 7.085V3h-1v4.085l-1.295-1.29L5.5 6.5 8 9l2.5-2.5z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "tray_default_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgTrayDefault;